import Avatar from '@mui/material/Avatar';
import React from 'react';
import PropTypes from 'prop-types';

import Utility from '../../Utility';
import {getAvatarColor} from '../../Utilities/ColorUtility';

function DynamicAvatar({imageSrc, className, style, user}) {
    if (!user) {
        return null;
    }
    if (imageSrc && imageSrc !== 'default') {
        return <Avatar className={className} style={style} src={imageSrc} data-testid="app-avatar-image"/>
    } else if (user.Name || user.GuestName || user.name) {
        let {AvatarBackground: avatarBackground, Name: firstName, LastName: lastName} = user;
        if(!firstName && user.GuestName){
            firstName = user.GuestName;
        }
        if(!firstName && !user.GuestName){
            firstName = user.name.split(' ')[0];
            lastName = user.name.split(' ')[1];
            avatarBackground = user.avatarUser.AvatarBackground;
        }
        const initials = Utility.getInitials(firstName, lastName);
        const bgColor = avatarBackground || getAvatarColor(user._id || user.Email || firstName);
        return (
            <Avatar
                className={className}
                style={{backgroundColor: bgColor, ...style}}
                data-testid="app-avatar-initials"
            >
                {initials}
            </Avatar>
        )
    } else {
        return <Avatar className={className + ' text'} style={style}/>

    }
}

DynamicAvatar.propTypes = {
    imageSrc: PropTypes.string,
    user: PropTypes.object.isRequired
};
export default DynamicAvatar;
